import React from 'react';
import { getSummaryContextMismatchReason } from '@Containers/Summary/hooks/useEntryStaleness';
import SummaryTrailingActions from './SummaryTrailingActions';

// FR-1.11: three distinct triggers share this acknowledgement-block mechanism, but their button
// sets differ and are not interchangeable. This is the neutral "Assistant panel's echo" variant —
// the Filters-panel's own nudge (with filter-category pills) is F8's concern, not this one.
function StaleSummaryNudge({ entry, activeBreadcrumb, onSummarizeTop, onSummarizeSelected, selectionError }) {
  const reason = getSummaryContextMismatchReason(entry, activeBreadcrumb);
  if (!reason) return null;

  const copy = {
    FILTER: {
      heading: 'Your results have been narrowed',
      body: 'Would you like a summary of these results?',
      showTopButton: true,
    },
    SORT: {
      heading: 'Your results order has changed',
      body: 'This summary is based on the previous ranking. Generate a new summary to reflect your current results order.',
      showTopButton: true,
    },
    PAGE: {
      heading: 'Viewing different results?',
      body: `This summary references results on page ${entry.sourceResultParams?.pageNumber || 1}. Select results on this page to summarise them, or return to page ${entry.sourceResultParams?.pageNumber || 1} to view the original references.`,
      showTopButton: false,
    },
  }[reason];

  const actions = [];
  if (copy.showTopButton) {
    actions.push({
      dataE2e: 'summarize-results-button',
      label: 'Summarise results',
      onClick: onSummarizeTop,
      type: 'primary',
    });
  }
  let selectedActionType = reason === 'PAGE' ? 'primary' : 'secondary';
  if (selectionError) {
    selectedActionType = 'warn';
  }
  actions.push({
    dataE2e: 'summarize-selected-results-button',
    isSelectionAction: true,
    label: 'Summarise selected results',
    onClick: () => onSummarizeSelected(),
    type: selectedActionType,
  });

  return (
    <SummaryTrailingActions
      actions={actions}
      body={copy.body}
      heading={copy.heading}
      selectionError={selectionError}
      testId="summary-stale-nudge"
    />
  );
}

export default StaleSummaryNudge;
